<div class="main-container">

  <div class="container">

    <!-- Header -->
    <div class="top-section">

      <div>
        <p class="page-title">
          Explore Venues
        </p>

        <p class="page-subtitle">
          Find sports venues, trainers and services near you
        </p>
      </div>

      <!-- Search -->
      <div class="search-wrapper">

        <div class="search-box">

          <input
            type="text"
            class="search-input"
            placeholder="Search by venue, city or locality..."
            [(ngModel)]="searchText"
            (input)="filterTenants()"
          />

          <span class="search-icon">
            🔍
          </span>

        </div>

      </div>

    </div>

    <div *ngIf="isLoading" class="text-center py-5" role="status" aria-label="Loading venues">
      <span class="spinner-border" aria-hidden="true"></span>
    </div>

    <!-- Tenant Grid -->
    <div *ngIf="loadError && !isLoading" class="text-center py-5" role="alert">
      <p>{{ loadError }}</p>
      <button type="button" class="btn btn-primary" (click)="getAllTenants()">Try again</button>
    </div>

    <div class="tenant-grid" *ngIf="!isLoading && !loadError">

      <div
        class="tenant-card-home"
        *ngFor="let tenant of filteredTenants"
        (click)="productDetails(tenant.id)"
      >

        <!-- Image -->
        <ng-container
          *ngIf="tenantImagesObj[tenant.id]?.length > 0; else noImageBlock">

          <img
            [src]="tenantImagesObj[tenant.id][0]?.image"
            class="tenant-home-image"
            alt="Venue Image"
          />

        </ng-container>

        <ng-template #noImageBlock>

          <img
            src="../assets/img/noImage.png"
            class="tenant-home-image"
            alt="No Image"
          />

        </ng-template>

        <!-- Details -->
        <div class="tenant-home-details">

          <div class="tenant-home-name">
            {{ tenant.tenantName }}
          </div>

          <div class="tenant-home-address">
            {{ tenant.address?.addressLine1 }}
          </div>

          <div class="tenant-home-city">
            {{ tenant.address?.city }}
          </div>

          <div class="tenant-home-services">

            <img
              *ngFor="let icon of tenantServiceIcons[tenant.id]"
              [src]="icon"
              class="service-icon"
              alt="Service"
            />

          </div>

<!--          <button
            type="button"
            class="book-now-btn"
            (click)="productDetails(tenant.id); $event.stopPropagation()">

            Book Now

          </button>-->

        </div>

      </div>

    </div>

    <!-- Empty State -->
    <div
      class="empty-state"
      *ngIf="!isLoading && !loadError && filteredTenants.length === 0">

      No venues found.

    </div>

  </div>

</div>

<!--
<div class="main-container">
  <div style="background-color:#fff;">
    <div class="container" style="min-height:700px;">
      <div *ngFor="let group of groupedByCity" class="city-section">
        <h4 class="city-heading">{{ group.city }}</h4>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-4"
               *ngFor="let tenant of group.tenants"
               style="margin-bottom:24px;">
            <div class="tenant-card">

              &lt;!&ndash; Image slider or fallback &ndash;&gt;
              <ng-container *ngIf="tenantImagesObj[tenant.id]?.length > 0; else noImageBlock">
                <div class="ng-slider" style="border-radius: 10px;">
                  <ng-image-slider
                    [images]="tenantImagesObj[tenant.id]"
                    slideImage="1"
                    [imageSize]="{ width: '100%', height: 250 }"
                    #nav>
                  </ng-image-slider>
                </div>
              </ng-container>

              <ng-template #noImageBlock>
                <img
                  src="../assets/img/noImage.png"
                  alt="No Image"
                  class="tenant-img"
                />
              </ng-template>

              <h6 class="tenant-name">{{ tenant.tenantName }}</h6>
&lt;!&ndash;
              <p *ngIf="getAllPhoneNumbers(tenant)">
                <img src="../../assets/img/phone-504.svg" style="height: 15px;width: 20px;" />
              </p>&ndash;&gt;

              <div class="button-wrapper">
                <button
                  type="button"
                  (click)="productDetails(tenant?.id)"
                  class="btn btn-secondary book-now-btn">
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> &lt;!&ndash; /city-section &ndash;&gt;
    </div>
  </div>
</div>

-->
